import { render } from "./disciplinaAll.vue?vue&type=template&id=47bd0230&scoped=true"
import script from "./disciplinaAll.vue?vue&type=script&lang=js"
export * from "./disciplinaAll.vue?vue&type=script&lang=js"

import "./disciplinaAll.vue?vue&type=style&index=0&id=47bd0230&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47bd0230"]])

export default __exports__